import type { MockRecord } from './database.ts';

export function productPslId(product: MockRecord): string {
  return String(product.pslId ?? product.pslID ?? product.pslid ?? '').trim();
}

export function belongsToPsl(product: MockRecord, pslId: unknown): boolean {
  return Boolean(pslId) && productPslId(product) === String(pslId);
}

export function isEligibleVqcaProduct(product: MockRecord, pslId: unknown): boolean {
  return product.status === 11 && product.isActive !== false && belongsToPsl(product, pslId);
}